import React from "react";
import "./achievementComponent.css";
import OptimizedSlideshow from '../projects/OptimizedSlideshow';





const ExpressFM = () => {
    const mediaItems = [

        // Add local video - uncomment and add actual video file
        {
            type: 'video',
            src: require('./images/expressfm.mp4')
        }
    ];

    return (
    <section className="RedRadio section" id="RedRadio">
        <h2 className="section__title">Express FM</h2>
        <span className="section__subtitle">Featured Guest</span>
        <OptimizedSlideshow mediaItems={mediaItems} />
        
        <div className="about__container container grid">
           

            <div className="text__container1">
                <h3 className="title">Description:</h3>
                <div className="achievement__content">
                    <p className='redRadio__text'>
                        🎙️ Invited to <strong>EXPRESS FM</strong> to discuss the importance of sharing knowledge about <strong>Artificial Intelligence</strong> and promoting AI literacy among the public.
                    </p>
                    <p className='redRadio__text'>
                        🤝 Proudly represented <strong>DeepFlow</strong>, an AI community driven by the vision <strong>"AI FOR ALL"</strong> 💪✨ — empowering people to understand, use, and innovate with AI.
                    </p>
                </div>
            </div>
        </div>
    </section>
    );
};

export default ExpressFM;
